import CloseIcon from 'assets/ver2/icons/close-blue-icon.svg';
import ArrowDownIcon from 'assets/ver2/icons/double-arrow-down-green-icon.svg';
import BannerImageEn from 'assets/ver2/referral/referral-banner-mobile-en.png';
import BannerImageVi from 'assets/ver2/referral/referral-banner-mobile-vi.png';
import CustomQAAccordion from 'components/Profile/components/Referral/components/ReferralContent/CustomQAAccordion';
import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import { getImgSrcByLang } from 'components/common/func';
import { DESKTOP_MIN_WIDTH, REFERRAL_PREFIX } from 'constants';
import useReferral from 'features/referral/hooks/useReferral';
import useLang from 'hooks/useLang';
import useQuery from 'hooks/useQuery';
import { isNumber } from 'lodash';
import { useRef } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';
import RefereeTracking, {
  refereeTrackingClassName,
} from '../components/ReferralContent/RefereeTracking';
import ReferralContentTab3 from '../components/ReferralContentTab3';

const ReferralMobile = () => {
  const { t } = useLang();

  const {
    handleOnShare,
    formShareTitle,
    formShareDesc,
    formShareDesc2,
    labelOfShareButton,
    SendIcon,
    FormInputCopy,
    FormProgressBar,
    isReferee1st,
  } = useReferral();

  const navigate = useNavigate();
  const query = useQuery();
  const tab = query.get('tab');

  // const [isViewAll, setViewAll] = useState(false);
  // const isIntersecting = useDetectEndpointVisibleOnScreen();
  // const isIntersecting2 = useDetectEndpointVisibleOnScreenWithId('test');

  // useEffect(() => {
  //   setViewAll(true);
  // }, [isViewAll, isIntersecting]);

  const formShareRef = useRef();
  const getPaddingTopOfCustomQAAccordion = (h) => {
    if (isNumber(h)) return h + 8;
    return 196;
  };

  const bannerImageRef = useRef();

  const isTracking = Boolean(
    document.getElementsByClassName(refereeTrackingClassName)?.[0]
  );

  const handleOnClose = () => {
    navigate(REFERRAL_PREFIX);
  };

  return (
    <>
      <style>
        {`
          .referral-mobile-offcanvas {
            width: 100%!important;
            height: calc(100% - 70px);
            border: none!important;
          }
          .referral-mobile-offcanvas-backdrop {
            opacity: 0!important;
          }
        `}
      </style>

      <ReferralMobileStyled>
        <NavbarStyled expand={false} expanded={tab} onToggle={handleOnClose}>
          <NavbarOffcanvas
            id="offcanvasNavbar-expand-false"
            aria-labelledby="offcanvasNavbarLabel-expand-false"
            placement="end"
            className="referral-mobile-offcanvas"
            backdropClassName="referral-mobile-offcanvas-backdrop"
          >
            <OffcanvasHeader closeButton>
              <OffcanvasTitle id="offcanvasNavbarLabel-expand-false">
                {t('label_referral')}
              </OffcanvasTitle>
              <img
                src={CloseIcon}
                width={20}
                height={20}
                onClick={handleOnClose}
              />
            </OffcanvasHeader>
            <OffcanvasBody>
              <ImageWrap>
                <img
                  ref={bannerImageRef}
                  src={getImgSrcByLang(BannerImageEn, BannerImageVi)}
                  alt=""
                />
                <FormShare
                  ref={formShareRef}
                  $bannerImageHeight={bannerImageRef?.current?.offsetHeight}
                >
                  <FormShareTitle $isActive={isReferee1st}>
                    {formShareTitle}
                  </FormShareTitle>
                  <SizeBox height={4} />
                  <FormShareDesc>{formShareDesc}</FormShareDesc>
                  <FormShareDesc>{formShareDesc2}</FormShareDesc>
                  <SizeBox height={16} />
                  <FormInputCopy
                    isHideFormLabel
                    styles={{ marginBottom: '16px' }}
                  />
                  {FormProgressBar({
                    styles: { marginBottom: '16px', paddingInline: '10px' },
                  })}
                  <ButtonCommon
                    value={labelOfShareButton}
                    onClick={handleOnShare}
                    color="var(--c-primary)"
                    background="var(--bg-primary)"
                    isFill={true}
                    styles={{
                      textTransform: 'unset',
                      width: !SendIcon && '100%',
                      height: '50px',
                    }}
                    buttonIconStyles={{
                      textTransform: 'uppercase',
                      width: '100%',
                      height: '50px',
                      gap: 0,
                    }}
                    iconStyles={{
                      width: '24px',
                      borderRadius: 0,
                    }}
                    iconSrc={SendIcon}
                  />
                </FormShare>
              </ImageWrap>
              <RefereeTracking
                paddingTop={getPaddingTopOfCustomQAAccordion(
                  formShareRef?.current?.offsetHeight
                )}
              />
              <CustomQAAccordion
                paddingTop={
                  !isTracking &&
                  getPaddingTopOfCustomQAAccordion(
                    formShareRef?.current?.offsetHeight
                  )
                }
              />
              <SizeBox height={20} />
              <ReferralContentTab3 style={{ paddingInline: '16px' }} />
              <ScrollDownBlur $hidden={true}>
                <img src={ArrowDownIcon} width={24} height={24} />
              </ScrollDownBlur>
            </OffcanvasBody>
          </NavbarOffcanvas>
        </NavbarStyled>
      </ReferralMobileStyled>
    </>
  );
};

const ReferralMobileStyled = styled.div`
  position: relative;
`;

const NavbarStyled = styled(Navbar)`
  display: initial;
  position: absolute;
  top: -40px;
  right: 0;
  padding: 0;
  height: 40px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    top: unset;
    right: unset;
  }
`;

const NavbarOffcanvas = styled(Navbar.Offcanvas)`
  margin-top: 70px;
`;
const OffcanvasHeader = styled(Offcanvas.Header)`
  min-height: 40px;
  padding: 0 16px;
  border-bottom: 1px solid #ececf0;

  display: flex;
  justify-content: space-between;

  & button {
    display: none;
  }

  & span {
    font-family: var(--ff-primary);
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    color: var(--ds-c-sky);
    cursor: pointer;
    user-select: none;

    &:hover {
      color: var(--ds-c-sky-hover);
    }
  }
`;
const OffcanvasTitle = styled(Offcanvas.Title)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  color: #000;
`;
const OffcanvasBody = styled(Offcanvas.Body)`
  padding-inline: 0px;
  padding-block: 0px;
  padding-bottom: 24px;
`;

const ImageWrap = styled.div`
  position: relative;
  left: 16px;
  width: 100%;
  margin-inline: -16px;
  display: flex;
  justify-content: center;
  margin-bottom: 0px;

  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 10px;
  }
`;
const FormShare = styled.div`
  position: absolute;
  top: ${(props) =>
    `calc(${
      props.$bannerImageHeight ? `${props.$bannerImageHeight}px` : `100%`
    } - 8px)`};
  width: calc(100% - 32px);
  height: fit-content;
  border-radius: 12px;
  box-shadow: 0px 4px 15px 0px #0000001a;
  padding: 16px 10px;
  background-color: #fff;
`;
const FormShareTitle = styled.p`
  ${paragraphMixin};
  font-family: var(--ff-tertiary);
  font-size: 20px;
  line-height: 25px;
  text-transform: uppercase;
  margin-bottom: 0px;
  text-align: center;
  color: ${(props) => (props.$isActive ? '#0000BE' : '#000')};
`;
const FormShareDesc = styled.p`
  ${paragraphMixin};
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 0px;
  font-weight: 500;
  text-align: center;
`;

const ScrollDownBlur = styled.div`
  position: fixed;
  z-index: 1;
  bottom: 70px;
  width: 100% !important;
  height: 60px;
  border: none;
  border-radius: 0;
  padding: 16px;
  backdrop-filter: blur(10px);
  display: flex;
  & img {
    margin-inline: auto;
  }
  display: ${(props) => props.$hidden && 'none'};
`;

export default ReferralMobile;
